import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import TrendingUp from "@material-ui/icons/TrendingUp";
import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import theme from "styles/theme";

interface IBadgeProps {
    name: string;
    tooltipTextList: string[];
    tooltipTitle: string;
    marginBottom?: boolean;
}

interface StyleProps {
    bottomMargin: string;
}

const useStyles = makeStyles<Theme, StyleProps>({
    tooltip: {
        backgroundColor: "#2D2D2D",
        color: "#F0F2F2",
        width: "234px",
        fontSize: "12px",
        padding: "4px 8px",
        borderRadius: "4px",
    },
    badge: {
        display: "flex",
        alignItems: "center",
        fontWeight: 400,
        fontSize: "14px",
        width: "fit-content",
        border: "2px solid lightgrey",
        borderRadius: "8px",
        color: "#2D2D2D",
        marginBottom: ({ bottomMargin }) => bottomMargin,
    },
    icon: {
        marginRight: "5px",
        marginLeft: "8px",
        color: theme.palette.primary1Color,
    },
    title: {
        fontSize: "12px",
        marginBottom: 0,
        marginTop: 0,
        fontWeight: 700,
    },
    tooltip_badge_category: {
        marginTop: "8px",
    },
    name: {
        marginRight: "8px",
    },
});

const TopProductTooltip: React.FC<IBadgeProps> = ({ name, tooltipTitle, tooltipTextList, marginBottom = true }) => {
    const styleProps = {
        bottomMargin: marginBottom ? "10px" : "0px",
    };
    const classes = useStyles(styleProps);

    return (
        <Tooltip
            title={
                <div>
                    <h3 className={classes.title}>{tooltipTitle}</h3>
                    {tooltipTextList.map((text) => (
                        <div key={text} className={classes.tooltip_badge_category}>
                            {text}
                        </div>
                    ))}
                </div>
            }
            classes={{ tooltip: classes.tooltip }}
        >
            <div className={classes.badge}>
                <TrendingUp fontSize="large" className={classes.icon} />
                <div className={classes.name}>{name}</div>
            </div>
        </Tooltip>
    );
};

export default TopProductTooltip;
